import { Payload } from "@neworbit/redux-helpers";
import { Dispatch } from "redux";
import axios from "axios";
import { loadAndTrack } from "redux-request-loading";

import { CustomerSraDepartment } from "@teamprevent/common/customerSraDepartment/model";

import { CustomerSraDepartmentsApi } from "./CustomerSraDepartmentsApi";
import * as actionTypes from "./actionTypes";

type LoadCustomerSraDepartmentsSuccessAction = { type: typeof actionTypes.LOAD_CUSTOMER_SRA_DEPARTMENTS_SUCCESS } & Payload<CustomerSraDepartment[]>;

export type CustomerSraDepartmentsAction = LoadCustomerSraDepartmentsSuccessAction;

function buildLoadCustomerSraDepartments(customerSraDepartmentsApi: CustomerSraDepartmentsApi) {
    return () => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, actionTypes.LOAD_CUSTOMER_SRA_DEPARTMENTS, customerSraDepartmentsApi.load());
            dispatch(loadCustomerSraDepartmentsSuccess(result));
        };
    };
}

export const loadCustomerSraDepartments = buildLoadCustomerSraDepartments(new CustomerSraDepartmentsApi(axios));

export function loadCustomerSraDepartmentsSuccess(customerSraDepartments: CustomerSraDepartment[]): LoadCustomerSraDepartmentsSuccessAction {
    return {
        type: actionTypes.LOAD_CUSTOMER_SRA_DEPARTMENTS_SUCCESS,
        payload: customerSraDepartments
    };
}
